// extracted by mini-css-extract-plugin
export default {"root":"styles_root__zUgQa","panel":"styles_panel__v0eRg","panel__search":"styles_panel__search__Gc73v","panel__toggle":"styles_panel__toggle__drjZy"};